import { render, staticRenderFns } from "./TimerComponent.vue?vue&type=template&id=35591ba5"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"
import style0 from "./TimerComponent.vue?vue&type=style&index=0&id=35591ba5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports